import { useShallow } from "zustand/react/shallow";

import type { Session } from "../types";

import { useSessionStore } from "../session.store";

export function useSession() {
    return useSessionStore(useShallow((state) => state.computed.selectedSession() as unknown as Session));
}
